import React from "react";
import { DRProvider } from "./pages/dashboards/supervisordaily/DRContext";
import { ReportProvider } from "./pages/reports/reportContext";
export const Contexts = ({ children }) => {
  return (
    <ReportProvider>
      <DRProvider>{children}</DRProvider>
    </ReportProvider>
  );
};
